export const staticCardData = {
  101: [
    { Place: "INDIA", Prevalence: 0.2, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 0.16, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 0.62, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 0.25, year: 2023 },
    { Place: "ASSAM", Prevalence: 0.13, year: 2023 },
    { Place: "BIHAR", Prevalence: 0.16, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 0.26, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 0.16, year: 2023 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 0.18, year: 2023 },
    { Place: "DAMAN AND DIU", Prevalence: 0.18, year: 2023 },
    { Place: "DELHI", Prevalence: 0.31, year: 2023 },
    { Place: "GOA", Prevalence: 0.29, year: 2023 },
    { Place: "GUJARAT", Prevalence: 0.19, year: 2023 },
    { Place: "HARYANA", Prevalence: 0.23, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 0.11, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 0.06, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 0.07, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 0.42, year: 2023 },
    { Place: "KERALA", Prevalence: 0.07, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 0.1, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 0.29, year: 2023 },
    { Place: "MANIPUR", Prevalence: 0.87, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 0.43, year: 2023 },
    { Place: "MIZORAM", Prevalence: 2.73, year: 2023 },
    { Place: "NAGALAND", Prevalence: 1.37, year: 2023 },
    { Place: "ODISHA", Prevalence: 0.12, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 0.18, year: 2023 },
    { Place: "PUNJAB", Prevalence: 0.42, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 0.12, year: 2023 },
    { Place: "SIKKIM", Prevalence: 0.11, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 0.2, year: 2023 },
    { Place: "TELANGANA", Prevalence: 0.44, year: 2023 },
    { Place: "TRIPURA", Prevalence: 0.37, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 0.1, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 0.13, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 0.08, year: 2023 },

    { Place: "INDIA", Prevalence: 0.2, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 0.16, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 0.58, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 0.22, year: 2025 },
    { Place: "ASSAM", Prevalence: 0.13, year: 2025 },
    { Place: "BIHAR", Prevalence: 0.16, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 0.29, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 0.15, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 0.18, year: 2025 },
    // { Place: "DAMAN AND DIU", Prevalence: 0.18, year: 2025 },
    { Place: "DELHI", Prevalence: 0.3, year: 2025 },
    { Place: "GOA", Prevalence: 0.27, year: 2025 },
    { Place: "GUJARAT", Prevalence: 0.18, year: 2025 },
    { Place: "HARYANA", Prevalence: 0.24, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 0.11, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 0.06, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 0.07, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 0.44, year: 2025 },
    { Place: "KERALA", Prevalence: 0.07, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 0.1, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 0.29, year: 2025 },
    { Place: "MANIPUR", Prevalence: 0.81, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 0.4, year: 2025 },
    { Place: "MIZORAM", Prevalence: 2.75, year: 2025 },
    { Place: "NAGALAND", Prevalence: 1.39, year: 2025 },
    { Place: "ODISHA", Prevalence: 0.12, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 0.16, year: 2025 },
    { Place: "PUNJAB", Prevalence: 0.42, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 0.13, year: 2025 },
    { Place: "SIKKIM", Prevalence: 0.1, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 0.19, year: 2025 },
    { Place: "TELANGANA", Prevalence: 0.41, year: 2025 },
    { Place: "TRIPURA", Prevalence: 0.39, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 0.1, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 0.13, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 0.08, year: 2025 },
  ],
  102: [
    { Place: "INDIA", Prevalence: 0.23, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 0.13, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 0.3, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 0.03, year: 2023 },
    { Place: "ASSAM", Prevalence: 0.24, year: 2023 },
    { Place: "BIHAR", Prevalence: 0.16, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 0, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 0.29, year: 2023 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 0.17, year: 2023 },
    { Place: "DAMAN AND DIU", Prevalence: 0.17, year: 2023 },
    { Place: "DELHI", Prevalence: 0.25, year: 2023 },
    { Place: "GOA", Prevalence: 0.08, year: 2023 },
    { Place: "GUJARAT", Prevalence: 0.26, year: 2023 },
    { Place: "HARYANA", Prevalence: 0.11, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 0.08, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 0.02, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 0.18, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 0.57, year: 2023 },
    { Place: "KERALA", Prevalence: 0.11, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 0.12, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 0.36, year: 2023 },
    { Place: "MANIPUR", Prevalence: 0.32, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 0.58, year: 2023 },
    { Place: "MIZORAM", Prevalence: 0.63, year: 2023 },
    { Place: "NAGALAND", Prevalence: 0.51, year: 2023 },
    { Place: "ODISHA", Prevalence: 0.33, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 0, year: 2023 },
    { Place: "PUNJAB", Prevalence: 0.23, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 0.21, year: 2023 },
    { Place: "SIKKIM", Prevalence: 0.16, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 0.16, year: 2023 },
    { Place: "TELANGANA", Prevalence: 0.32, year: 2023 },
    { Place: "TRIPURA", Prevalence: 0.43, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 0.12, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 0.06, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 0.11, year: 2023 },

    // { Place: "INDIA", Prevalence: 0.23, year: 2025 },
    // { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 0.13, year: 2025 },
    // { Place: "ANDHRA PRADESH", Prevalence: 0.3, year: 2025 },
    // { Place: "ARUNACHAL PRADESH", Prevalence: 0.03, year: 2025 },
    // { Place: "ASSAM", Prevalence: 0.24, year: 2025 },
    // { Place: "BIHAR", Prevalence: 0.16, year: 2025 },
    // { Place: "CHANDIGARH", Prevalence: 0, year: 2025 },
    // { Place: "CHHATTISGARH", Prevalence: 0.29, year: 2025 },
    // { Place: "DADRA & NAGAR HAVELI", Prevalence: 0.17, year: 2025 },
    // { Place: "DAMAN AND DIU", Prevalence: 0.17, year: 2025 },
    // { Place: "DELHI", Prevalence: 0.25, year: 2025 },
    // { Place: "GOA", Prevalence: 0.08, year: 2025 },
    // { Place: "GUJARAT", Prevalence: 0.26, year: 2025 },
    // { Place: "HARYANA", Prevalence: 0.12, year: 2025 },
    // { Place: "HIMACHAL PRADESH", Prevalence: 0.08, year: 2025 },
    // { Place: "JAMMU AND KASHMIR", Prevalence: 0.02, year: 2025 },
    // { Place: "JHARKHAND", Prevalence: 0.18, year: 2025 },
    // { Place: "KARNATAKA", Prevalence: 0.57, year: 2025 },
    // { Place: "KERALA", Prevalence: 0.11, year: 2025 },
    // { Place: "MADHYA PRADESH", Prevalence: 0.12, year: 2025 },
    // { Place: "MAHARASHTRA", Prevalence: 0.36, year: 2025 },
    // { Place: "MANIPUR", Prevalence: 0.32, year: 2025 },
    // { Place: "MEGHALAYA", Prevalence: 0.58, year: 2025 },
    // { Place: "MIZORAM", Prevalence: 0.63, year: 2025 },
    // { Place: "NAGALAND", Prevalence: 0.51, year: 2025 },
    // { Place: "ODISHA", Prevalence: 0.33, year: 2025 },
    // { Place: "PUDUCHERRY", Prevalence: 0, year: 2025 },
    // { Place: "PUNJAB", Prevalence: 0.23, year: 2025 },
    // { Place: "RAJASTHAN", Prevalence: 0.21, year: 2025 },
    // { Place: "SIKKIM", Prevalence: 0.16, year: 2025 },
    // { Place: "TAMIL NADU", Prevalence: 0.16, year: 2025 },
    // { Place: "TELANGANA", Prevalence: 0.32, year: 2025 },
    // { Place: "TRIPURA", Prevalence: 0.43, year: 2025 },
    // { Place: "UTTAR PRADESH", Prevalence: 0.12, year: 2025 },
    // { Place: "UTTARAKHAND", Prevalence: 0.06, year: 2025 },
    // { Place: "WEST BENGAL", Prevalence: 0.11, year: 2025 },
  ],
  104: [
    { Place: "INDIA", Prevalence: 28485238, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 5049, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 824603, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 27029, year: 2023 },
    { Place: "ASSAM", Prevalence: 597564, year: 2023 },
    { Place: "BIHAR", Prevalence: 3371766, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 29970, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 630453, year: 2023 },
    { Place: "DELHI", Prevalence: 446052, year: 2023 },
    { Place: "GOA", Prevalence: 18850, year: 2023 },
    { Place: "GUJARAT", Prevalence: 1361625, year: 2023 },
    { Place: "HARYANA", Prevalence: 555715, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 103035, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 273541, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 1012846, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 1159827, year: 2023 },
    { Place: "KERALA", Prevalence: 420170, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 1838843, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 2192924, year: 2023 },
    { Place: "MANIPUR", Prevalence: 59589, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 102139, year: 2023 },
    { Place: "MIZORAM", Prevalence: 20870, year: 2023 },
    { Place: "NAGALAND", Prevalence: 26660, year: 2023 },
    { Place: "ODISHA", Prevalence: 644760, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 17832, year: 2023 },
    { Place: "PUNJAB", Prevalence: 428047, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 1766228, year: 2023 },
    { Place: "SIKKIM", Prevalence: 7323, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 956988, year: 2023 },
    { Place: "TELANGANA", Prevalence: 779736, year: 2023 },
    { Place: "TRIPURA", Prevalence: 53849, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 7061380, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 188546, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 1483441, year: 2023 },

    { Place: "INDIA", Prevalence: 28197268, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 3902, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 805331, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 27132, year: 2025 },
    { Place: "ASSAM", Prevalence: 637436, year: 2025 },
    { Place: "BIHAR", Prevalence: 3434808, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 27177, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 611185, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 11585, year: 2025 },
    { Place: "DELHI", Prevalence: 486550, year: 2025 },
    { Place: "GOA", Prevalence: 20817, year: 2025 },
    { Place: "GUJARAT", Prevalence: 1304846, year: 2025 },
    { Place: "HARYANA", Prevalence: 562859, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 98233, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 248716, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 963500, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 1212570, year: 2025 },
    { Place: "KERALA", Prevalence: 519910, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 2285350, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 1981953, year: 2025 },
    { Place: "MANIPUR", Prevalence: 53310, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 81530, year: 2025 },
    { Place: "MIZORAM", Prevalence: 19440, year: 2025 },
    { Place: "NAGALAND", Prevalence: 22790, year: 2025 },
    { Place: "ODISHA", Prevalence: 623978, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 27986, year: 2025 },
    { Place: "PUNJAB", Prevalence: 404605, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 1669826, year: 2025 },
    { Place: "SIKKIM", Prevalence: 7189, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 902994, year: 2025 },
    { Place: "TELANGANA", Prevalence: 679805, year: 2025 },
    { Place: "TRIPURA", Prevalence: 52684, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 7196121, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 190848, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 1451199, year: 2025 },
  ],
  105: [
    { Place: "INDIA", Prevalence: 30191460, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 4840, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 923200, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 28900, year: 2023 },
    { Place: "ASSAM", Prevalence: 823820, year: 2023 },
    { Place: "BIHAR", Prevalence: 3530140, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 18190, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 712470, year: 2023 },
    { Place: "DELHI", Prevalence: 360500, year: 2023 },
    { Place: "GOA", Prevalence: 22110, year: 2023 },
    { Place: "GUJARAT", Prevalence: 1505120, year: 2023 },
    { Place: "HARYANA", Prevalence: 684080, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 129270, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 215790, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 951600, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 1205060, year: 2023 },
    { Place: "KERALA", Prevalence: 517840, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 2258620, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 2115690, year: 2023 },
    { Place: "MANIPUR", Prevalence: 52850, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 80810, year: 2023 },
    { Place: "MIZORAM", Prevalence: 19270, year: 2023 },
    { Place: "NAGALAND", Prevalence: 29970, year: 2023 },
    { Place: "ODISHA", Prevalence: 934720, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 25120, year: 2023 },
    { Place: "PUNJAB", Prevalence: 491800, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 2088490, year: 2023 },
    { Place: "SIKKIM", Prevalence: 11700, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 1188940, year: 2023 },
    { Place: "TELANGANA", Prevalence: 687530, year: 2023 },
    { Place: "TRIPURA", Prevalence: 59090, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 6641050, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 217250, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 1624780, year: 2023 },

    { Place: "INDIA", Prevalence: 29567935, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 4016, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 839160, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 27817, year: 2025 },
    { Place: "ASSAM", Prevalence: 732178, year: 2025 },
    { Place: "BIHAR", Prevalence: 3559146, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 15372, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 744239, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 14372, year: 2025 },
    { Place: "DELHI", Prevalence: 370321, year: 2025 },
    { Place: "GOA", Prevalence: 17759, year: 2025 },
    { Place: "GUJARAT", Prevalence: 1346089, year: 2025 },
    { Place: "HARYANA", Prevalence: 606650, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 105951, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 220305, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 1020306, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 1095291, year: 2025 },
    { Place: "KERALA", Prevalence: 373288, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 2153045, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 2190879, year: 2025 },
    { Place: "MANIPUR", Prevalence: 50815, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 92499, year: 2025 },
    { Place: "MIZORAM", Prevalence: 23116, year: 2025 },
    { Place: "NAGALAND", Prevalence: 23913, year: 2025 },
    { Place: "ODISHA", Prevalence: 753141, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 13870, year: 2025 },
    { Place: "PUNJAB", Prevalence: 433515, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 1979619, year: 2025 },
    { Place: "SIKKIM", Prevalence: 7990, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 974875, year: 2025 },
    { Place: "TELANGANA", Prevalence: 660184, year: 2025 },
    { Place: "TRIPURA", Prevalence: 56828, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 7288843, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 212399, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 1555425, year: 2025 },
  ],
  106: [
    { Place: "INDIA", Prevalence: 2544365, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 513, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 320222, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 2465, year: 2023 },
    { Place: "ASSAM", Prevalence: 32031, year: 2023 },
    { Place: "BIHAR", Prevalence: 155646, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 2596, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 40169, year: 2023 },
    {
      Place: "DADRA & NAGAR HAVELI & DAMAN & DIU",
      Prevalence: 1752,
      year: 2023,
    },
    { Place: "DELHI", Prevalence: 58869, year: 2023 },
    { Place: "GOA", Prevalence: 4474, year: 2023 },
    { Place: "GUJARAT", Prevalence: 120312, year: 2023 },
    { Place: "HARYANA", Prevalence: 56578, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 7883, year: 2023 },
    { Place: "JAMMU AND KASHMIR & LADAKH", Prevalence: 6689, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 23794, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 280497, year: 2023 },
    { Place: "KERALA", Prevalence: 24416, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 70170, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 389629, year: 2023 },
    { Place: "MANIPUR", Prevalence: 24472, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 9501, year: 2023 },
    { Place: "MIZORAM", Prevalence: 25294, year: 2023 },
    { Place: "NAGALAND", Prevalence: 23086, year: 2023 },
    { Place: "ODISHA", Prevalence: 47508, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 2793, year: 2023 },
    { Place: "PUNJAB", Prevalence: 105791, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 82454, year: 2023 },
    { Place: "SIKKIM", Prevalence: 605, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 168893, year: 2023 },
    { Place: "TELANGANA", Prevalence: 158164, year: 2023 },
    { Place: "TRIPURA", Prevalence: 10126, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 197451, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 12301, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 77220, year: 2023 },

    { Place: "INDIA", Prevalence: 2561161, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 501, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 310451, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 2630, year: 2025 },
    { Place: "ASSAM", Prevalence: 33148, year: 2025 },
    { Place: "BIHAR", Prevalence: 154296, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 3016, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 38276, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 1923, year: 2025 },
    { Place: "DELHI", Prevalence: 59079, year: 2025 },
    { Place: "GOA", Prevalence: 4376, year: 2025 },
    { Place: "GUJARAT", Prevalence: 120799, year: 2025 },
    { Place: "HARYANA", Prevalence: 59642, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 7953, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 6766, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 24268, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 291348, year: 2025 },
    { Place: "KERALA", Prevalence: 23608, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 69935, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 399023, year: 2025 },
    { Place: "MANIPUR", Prevalence: 23463, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 9244, year: 2025 },
    { Place: "MIZORAM", Prevalence: 26321, year: 2025 },
    { Place: "NAGALAND", Prevalence: 23731, year: 2025 },
    { Place: "ODISHA", Prevalence: 46919, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 2625, year: 2025 },
    { Place: "PUNJAB", Prevalence: 110715, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 86143, year: 2025 },
    { Place: "SIKKIM", Prevalence: 533, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 165971, year: 2025 },
    { Place: "TELANGANA", Prevalence: 156961, year: 2025 },
    { Place: "TRIPURA", Prevalence: 10769, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 195427, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 12902, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 78399, year: 2025 },
  ],
  107: [
    { Place: "INDIA", Prevalence: 63044, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 17, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 5209, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 51, year: 2023 },
    { Place: "ASSAM", Prevalence: 635, year: 2023 },
    { Place: "BIHAR", Prevalence: 6333, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 48, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 1675, year: 2023 },
    { Place: "DELHI", Prevalence: 1356, year: 2023 },
    { Place: "GOA", Prevalence: 86, year: 2023 },
    { Place: "GUJARAT", Prevalence: 3372, year: 2023 },
    { Place: "HARYANA", Prevalence: 1380, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 149, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 130, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 1129, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 5586, year: 2023 },
    { Place: "KERALA", Prevalence: 510, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 2423, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 8958, year: 2023 },
    { Place: "MANIPUR", Prevalence: 718, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 363, year: 2023 },
    { Place: "MIZORAM", Prevalence: 703, year: 2023 },
    { Place: "NAGALAND", Prevalence: 869, year: 2023 },
    { Place: "ODISHA", Prevalence: 1585, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 1, year: 2023 },
    { Place: "PUNJAB", Prevalence: 1924, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 2539, year: 2023 },
    { Place: "SIKKIM", Prevalence: 29, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 3051, year: 2023 },
    { Place: "TELANGANA", Prevalence: 3293, year: 2023 },
    { Place: "TRIPURA", Prevalence: 153, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 5885, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 328, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 2476, year: 2023 },

    { Place: "INDIA", Prevalence: 56971, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 16, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 4337, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 51, year: 2025 },
    { Place: "ASSAM", Prevalence: 615, year: 2025 },
    { Place: "BIHAR", Prevalence: 5418, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 48, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 1547, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 28, year: 2025 },
    { Place: "DELHI", Prevalence: 1218, year: 2025 },
    { Place: "GOA", Prevalence: 76, year: 2025 },
    { Place: "GUJARAT", Prevalence: 2965, year: 2025 },
    { Place: "HARYANA", Prevalence: 1531, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 136, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 120, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 1032, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 4213, year: 2025 },
    { Place: "KERALA", Prevalence: 376, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 2151, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 8497, year: 2025 },
    { Place: "MANIPUR", Prevalence: 646, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 351, year: 2025 },
    { Place: "MIZORAM", Prevalence: 806, year: 2025 },
    { Place: "NAGALAND", Prevalence: 838, year: 2025 },
    { Place: "ODISHA", Prevalence: 1530, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 44, year: 2025 },
    { Place: "PUNJAB", Prevalence: 2046, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 2278, year: 2025 },
    { Place: "SIKKIM", Prevalence: 21, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 2691, year: 2025 },
    { Place: "TELANGANA", Prevalence: 2994, year: 2025 },
    { Place: "TRIPURA", Prevalence: 168, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 5886, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 330, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 1967, year: 2025 },
  ],
  108: [
    { Place: "INDIA", Prevalence: 163000, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 40, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 17390, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 282, year: 2023 },
    { Place: "ASSAM", Prevalence: 2036, year: 2023 },
    { Place: "BIHAR", Prevalence: 15115, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 205, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 3148, year: 2023 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 179, year: 2023 },
    { Place: "DELHI", Prevalence: 3693, year: 2023 },
    { Place: "GOA", Prevalence: 286, year: 2023 },
    { Place: "GUJARAT", Prevalence: 6482, year: 2023 },
    { Place: "HARYANA", Prevalence: 3984, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 346, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 336, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 1648, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 15817, year: 2023 },
    { Place: "KERALA", Prevalence: 972, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 5338, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 18993, year: 2023 },
    { Place: "MANIPUR", Prevalence: 1488, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 1441, year: 2023 },
    { Place: "MIZORAM", Prevalence: 2526, year: 2023 },
    { Place: "NAGALAND", Prevalence: 2499, year: 2023 },
    { Place: "ODISHA", Prevalence: 2863, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 176, year: 2023 },
    { Place: "PUNJAB", Prevalence: 9032, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 6502, year: 2023 },
    { Place: "SIKKIM", Prevalence: 59, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 7495, year: 2023 },
    { Place: "TELANGANA", Prevalence: 9248, year: 2023 },
    { Place: "TRIPURA", Prevalence: 954, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 16804, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 788, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 5022, year: 2023 },

    { Place: "INDIA", Prevalence: 155000, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 35, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 15673, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 281, year: 2025 },
    { Place: "ASSAM", Prevalence: 1913, year: 2025 },
    { Place: "BIHAR", Prevalence: 14201, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 255, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 2863, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 185, year: 2025 },
    { Place: "DELHI", Prevalence: 3689, year: 2025 },
    { Place: "GOA", Prevalence: 261, year: 2025 },
    { Place: "GUJARAT", Prevalence: 6291, year: 2025 },
    { Place: "HARYANA", Prevalence: 4115, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 361, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 351, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 1725, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 15362, year: 2025 },
    { Place: "KERALA", Prevalence: 829, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 4942, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 19199, year: 2025 },
    { Place: "MANIPUR", Prevalence: 1409, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 1231, year: 2025 },
    { Place: "MIZORAM", Prevalence: 2401, year: 2025 },
    { Place: "NAGALAND", Prevalence: 2465, year: 2025 },
    { Place: "ODISHA", Prevalence: 2725, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 154, year: 2025 },
    { Place: "PUNJAB", Prevalence: 7931, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 6875, year: 2025 },
    { Place: "SIKKIM", Prevalence: 49, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 6747, year: 2025 },
    { Place: "TELANGANA", Prevalence: 8201, year: 2025 },
    { Place: "TRIPURA", Prevalence: 909, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 15456, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 832, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 4942, year: 2025 },
  ],
  109: [
    { Place: "INDIA", Prevalence: 35862, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 10, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 5311, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 22, year: 2023 },
    { Place: "ASSAM", Prevalence: 337, year: 2023 },
    { Place: "BIHAR", Prevalence: 1838, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 17, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 984, year: 2023 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 12, year: 2023 },
    { Place: "DELHI", Prevalence: 1026, year: 2023 },
    { Place: "GOA", Prevalence: 33, year: 2023 },
    { Place: "GUJARAT", Prevalence: 800, year: 2023 },
    { Place: "HARYANA", Prevalence: 305, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 64, year: 2023 }, //doubt
    { Place: "JAMMU AND KASHMIR", Prevalence: 137, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 194, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 5599, year: 2023 },
    { Place: "KERALA", Prevalence: 288, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 1082, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 7462, year: 2023 },
    { Place: "MANIPUR", Prevalence: 490, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 52, year: 2023 },
    { Place: "MIZORAM", Prevalence: 133, year: 2023 },
    { Place: "NAGALAND", Prevalence: 214, year: 2023 },
    { Place: "ODISHA", Prevalence: 955, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 52, year: 2023 },
    { Place: "PUNJAB", Prevalence: 566, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 442, year: 2023 },
    { Place: "SIKKIM", Prevalence: 5, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 1867, year: 2023 },
    { Place: "TELANGANA", Prevalence: 2816, year: 2023 },
    { Place: "TRIPURA", Prevalence: 44, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 1816, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 184, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 709, year: 2023 },

    { Place: "INDIA", Prevalence: 32162, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 7, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 4364, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 16, year: 2025 },
    { Place: "ASSAM", Prevalence: 243, year: 2025 },
    { Place: "BIHAR", Prevalence: 1265, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 35, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 827, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 11, year: 2025 },
    { Place: "DELHI", Prevalence: 927, year: 2025 },
    { Place: "GOA", Prevalence: 24, year: 2025 },
    { Place: "GUJARAT", Prevalence: 697, year: 2025 },
    { Place: "HARYANA", Prevalence: 269, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 46, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 122, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 149, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 5675, year: 2025 },
    { Place: "KERALA", Prevalence: 221, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 720, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 6858, year: 2025 },
    { Place: "MANIPUR", Prevalence: 499, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 33, year: 2025 },
    { Place: "MIZORAM", Prevalence: 135, year: 2025 },
    { Place: "NAGALAND", Prevalence: 169, year: 2025 },
    { Place: "ODISHA", Prevalence: 825, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 40, year: 2025 },
    { Place: "PUNJAB", Prevalence: 961, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 388, year: 2025 },
    { Place: "SIKKIM", Prevalence: 2, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 1296, year: 2025 },
    { Place: "TELANGANA", Prevalence: 3035, year: 2025 },
    { Place: "TRIPURA", Prevalence: 50, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 1549, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 119, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 585, year: 2025 },
  ], //32162
  1010: [
    { Place: "INDIA", Prevalence: 19961, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 4, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 1797, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 25, year: 2023 },
    { Place: "ASSAM", Prevalence: 264, year: 2023 },
    { Place: "BIHAR", Prevalence: 1823, year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 17, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 430, year: 2023 },
    {
      Place: "DADRA & NAGAR HAVELI & DAMAN AND DIU",
      Prevalence: 8,
      year: 2023,
    },
    { Place: "DELHI", Prevalence: 408, year: 2023 },
    { Place: "GOA", Prevalence: 28, year: 2023 },
    { Place: "GUJARAT", Prevalence: 1121, year: 2023 },
    { Place: "HARYANA", Prevalence: 513, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 34, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 30, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 335, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 1662, year: 2023 },
    { Place: "KERALA", Prevalence: 102, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 817, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 2144, year: 2023 },
    { Place: "MANIPUR", Prevalence: 155, year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 299, year: 2023 },
    { Place: "MIZORAM", Prevalence: 292, year: 2023 },
    { Place: "NAGALAND", Prevalence: 288, year: 2023 },
    { Place: "ODISHA", Prevalence: 394, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 14, year: 2023 },
    { Place: "PUNJAB", Prevalence: 1027, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 992, year: 2023 },
    { Place: "SIKKIM", Prevalence: 10, year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 976, year: 2023 },
    { Place: "TELANGANA", Prevalence: 1118, year: 2023 },
    { Place: "TRIPURA", Prevalence: 65, year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 2097, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 80, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 592, year: 2023 },

    { Place: "INDIA", Prevalence: 18473, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 4, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 1686, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: 25, year: 2025 },
    { Place: "ASSAM", Prevalence: 262, year: 2025 },
    { Place: "BIHAR", Prevalence: 1389, year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 20, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 390, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 9, year: 2025 },
    // { Place: "DAMAN AND DIU", Prevalence: 9, year: 2025 },
    { Place: "DELHI", Prevalence: 377, year: 2025 },
    { Place: "GOA", Prevalence: 28, year: 2025 },
    { Place: "GUJARAT", Prevalence: 979, year: 2025 },
    { Place: "HARYANA", Prevalence: 579, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 32, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 29, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 307, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 1306, year: 2025 },
    { Place: "KERALA", Prevalence: 72, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 782, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 2087, year: 2025 },
    { Place: "MANIPUR", Prevalence: 155, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 284, year: 2025 },
    { Place: "MIZORAM", Prevalence: 347, year: 2025 },
    { Place: "NAGALAND", Prevalence: 297, year: 2025 },
    { Place: "ODISHA", Prevalence: 371, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 13, year: 2025 },
    { Place: "PUNJAB", Prevalence: 988, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 928, year: 2025 },
    { Place: "SIKKIM", Prevalence: 7, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 935, year: 2025 },
    { Place: "TELANGANA", Prevalence: 1018, year: 2025 },
    { Place: "TRIPURA", Prevalence: 73, year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 2101, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 84, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 509, year: 2025 },
  ],
  1011: [
    { Place: "INDIA", Prevalence: 11.75, year: 2023 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 0.36, year: 2023 },
    { Place: "ANDHRA PRADESH", Prevalence: 7.49, year: 2023 },
    { Place: "ARUNACHAL PRADESH", Prevalence: ">20", year: 2023 },
    { Place: "ASSAM", Prevalence: 19.63, year: 2023 },
    { Place: "BIHAR", Prevalence: ">20", year: 2023 },
    { Place: "CHANDIGARH", Prevalence: 6.4, year: 2023 },
    { Place: "CHHATTISGARH", Prevalence: 14.57, year: 2023 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 16.55, year: 2023 },
    { Place: "DELHI", Prevalence: 11.47, year: 2023 },
    { Place: "GOA", Prevalence: 10.29, year: 2023 },
    { Place: "GUJARAT", Prevalence: 9.74, year: 2023 },
    { Place: "HARYANA", Prevalence: 13.92, year: 2023 },
    { Place: "HIMACHAL PRADESH", Prevalence: 12.04, year: 2023 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 13.01, year: 2023 },
    { Place: "JHARKHAND", Prevalence: 12.54, year: 2023 },
    { Place: "KARNATAKA", Prevalence: 7.8, year: 2023 },
    { Place: "KERALA", Prevalence: 14.92, year: 2023 },
    { Place: "MADHYA PRADESH", Prevalence: 7.98, year: 2023 },
    { Place: "MAHARASHTRA", Prevalence: 5.87, year: 2023 },
    { Place: "MANIPUR", Prevalence: ">20", year: 2023 },
    { Place: "MEGHALAYA", Prevalence: 12.61, year: 2023 },
    { Place: "MIZORAM", Prevalence: 9.13, year: 2023 },
    { Place: "NAGALAND", Prevalence: 12.96, year: 2023 },
    { Place: "ODISHA", Prevalence: 11.78, year: 2023 },
    { Place: "PUDUCHERRY", Prevalence: 20, year: 2023 },
    { Place: "PUNJAB", Prevalence: 14.3, year: 2023 },
    { Place: "RAJASTHAN", Prevalence: 11.31, year: 2023 },
    { Place: "SIKKIM", Prevalence: ">20", year: 2023 },
    { Place: "TAMIL NADU", Prevalence: 5.65, year: 2023 },
    { Place: "TELANGANA", Prevalence: 8.44, year: 2023 },
    { Place: "TRIPURA", Prevalence: ">20", year: 2023 },
    { Place: "UTTAR PRADESH", Prevalence: 12.16, year: 2023 },
    { Place: "UTTARAKHAND", Prevalence: 18.64, year: 2023 },
    { Place: "WEST BENGAL", Prevalence: 8.72, year: 2023 },

    { Place: "INDIA", Prevalence: 10.25, year: 2025 },
    { Place: "ANDAMAN & NICOBAR ISLANDS", Prevalence: 0.36, year: 2025 },
    { Place: "ANDHRA PRADESH", Prevalence: 8.55, year: 2025 },
    { Place: "ARUNACHAL PRADESH", Prevalence: ">20", year: 2025 },
    { Place: "ASSAM", Prevalence: 16.86, year: 2025 },
    { Place: "BIHAR", Prevalence: ">20", year: 2025 },
    { Place: "CHANDIGARH", Prevalence: 10.22, year: 2025 },
    { Place: "CHHATTISGARH", Prevalence: 11.04, year: 2025 },
    { Place: "DADRA & NAGAR HAVELI", Prevalence: 16.55, year: 2025 },
    { Place: "DELHI", Prevalence: 12.71, year: 2025 },
    { Place: "GOA", Prevalence: 18.39, year: 2025 },
    { Place: "GUJARAT", Prevalence: 8.06, year: 2025 },
    { Place: "HARYANA", Prevalence: 9.45, year: 2025 },
    { Place: "HIMACHAL PRADESH", Prevalence: 12.4, year: 2025 },
    { Place: "JAMMU AND KASHMIR", Prevalence: 8.17, year: 2025 },
    { Place: "JHARKHAND", Prevalence: 11.99, year: 2025 },
    { Place: "KARNATAKA", Prevalence: 6.55, year: 2025 },
    { Place: "KERALA", Prevalence: 11.61, year: 2025 },
    { Place: "MADHYA PRADESH", Prevalence: 7.81, year: 2025 },
    { Place: "MAHARASHTRA", Prevalence: 5.89, year: 2025 },
    { Place: "MANIPUR", Prevalence: 14.33, year: 2025 },
    { Place: "MEGHALAYA", Prevalence: 9.97, year: 2025 },
    { Place: "MIZORAM", Prevalence: 8.28, year: 2025 },
    { Place: "NAGALAND", Prevalence: 11.1, year: 2025 },
    { Place: "ODISHA", Prevalence: 14.24, year: 2025 },
    { Place: "PUDUCHERRY", Prevalence: 18.79, year: 2025 },
    { Place: "PUNJAB", Prevalence: 11.18, year: 2025 },
    { Place: "RAJASTHAN", Prevalence: 14.77, year: 2025 },
    { Place: "SIKKIM", Prevalence: 14.02, year: 2025 },
    { Place: "TAMIL NADU", Prevalence: 4.82, year: 2025 },
    { Place: "TELANGANA", Prevalence: 6.87, year: 2025 },
    { Place: "TRIPURA", Prevalence: ">20", year: 2025 },
    { Place: "UTTAR PRADESH", Prevalence: 8.35, year: 2025 },
    { Place: "UTTARAKHAND", Prevalence: 16.4, year: 2025 },
    { Place: "WEST BENGAL", Prevalence: 8.99, year: 2025 },
  ],
  1012: [
    {
      Place: "ANDAMAN & NICOBAR ISLANDS",
      Status1: 43,
      Status2: 94.1,
      Status3: 95,
      year: 2023,
    },
    {
      Place: "ANDHRA PRADESH",
      Status1: 88.5,
      Status2: 85.4,
      Status3: 97.2,
      year: 2023,
    },
    {
      Place: "ARUNACHAL PRADESH",
      Status1: 92,
      Status2: 89.5,
      Status3: 94.5,
      year: 2023,
    },
    { Place: "ASSAM", Status1: 88, Status2: 70.4, Status3: 96.8, year: 2023 },
    { Place: "BIHAR", Status1: 66.5, Status2: 92.7, Status3: 94.2, year: 2023 },
    {
      Place: "CHANDIGARH",
      Status1: 95,
      Status2: 87,
      Status3: 99.8,
      year: 2023,
    },
    {
      Place: "CHHATTISGARH",
      Status1: 75,
      Status2: 78.1,
      Status3: 94.9,
      year: 2023,
    },
    {
      Place: "DADRA & NAGAR HAVELI",
      Status1: 34.6,
      Status2: 95,
      Status3: 92,
      year: 2023,
    },

    { Place: "DELHI", Status1: 95, Status2: 72.5, Status3: 98.5, year: 2023 },
    { Place: "GOA", Status1: 95, Status2: 74.4, Status3: 98.6, year: 2023 },
    {
      Place: "GUJARAT",
      Status1: 89.7,
      Status2: 85.6,
      Status3: 97.4,
      year: 2023,
    },
    {
      Place: "HARYANA",
      Status1: 78.5,
      Status2: 84.6,
      Status3: 96.2,
      year: 2023,
    },
    {
      Place: "HIMACHAL PRADESH",
      Status1: 92.7,
      Status2: 88.2,
      Status3: 96.5,
      year: 2023,
    },
    {
      Place: "JAMMU AND KASHMIR",
      Status1: 79.4,
      Status2: 77,
      Status3: 95.9,
      year: 2023,
    },
    {
      Place: "JHARKHAND",
      Status1: 89.8,
      Status2: 81.3,
      Status3: 96.8,
      year: 2023,
    },
    {
      Place: "KARNATAKA",
      Status1: 81.8,
      Status2: 85.6,
      Status3: 97.7,
      year: 2023,
    },
    { Place: "KERALA", Status1: 82.5, Status2: 95, Status3: 100, year: 2023 },
    { Place: "LAKSHADWEEP", Status1: 0, Status2: 87.5, Status3: 0, year: 2023 },
    {
      Place: "MADHYA PRADESH",
      Status1: 78.4,
      Status2: 90.4,
      Status3: 95.7,
      year: 2023,
    },
    {
      Place: "MAHARASHTRA",
      Status1: 89.6,
      Status2: 77.9,
      Status3: 98.5,
      year: 2023,
    },
    {
      Place: "MANIPUR",
      Status1: 86.4,
      Status2: 79.5,
      Status3: 99.1,
      year: 2023,
    },
    {
      Place: "MEGHALAYA",
      Status1: 94.2,
      Status2: 89.2,
      Status3: 96.4,
      year: 2023,
    },
    { Place: "MIZORAM", Status1: 77.4, Status2: 81, Status3: 97.9, year: 2023 },
    {
      Place: "NAGALAND",
      Status1: 86.6,
      Status2: 82.5,
      Status3: 98.9,
      year: 2023,
    },
    { Place: "ODISHA", Status1: 77, Status2: 83.9, Status3: 92.7, year: 2023 },
    {
      Place: "PUDUCHERRY",
      Status1: 68.1,
      Status2: 77.7,
      Status3: 97.7,
      year: 2023,
    },
    {
      Place: "PUNJAB",
      Status1: 83.1,
      Status2: 85.8,
      Status3: 95.9,
      year: 2023,
    },
    {
      Place: "RAJASTHAN",
      Status1: 85.9,
      Status2: 89.1,
      Status3: 94.5,
      year: 2023,
    },
    {
      Place: "SIKKIM",
      Status1: 87.4,
      Status2: 89.6,
      Status3: 98.1,
      year: 2023,
    },
    {
      Place: "TAMIL NADU",
      Status1: 93.8,
      Status2: 95,
      Status3: 97,
      year: 2023,
    },
    {
      Place: "TELANGANA",
      Status1: 83.6,
      Status2: 95,
      Status3: 97.3,
      year: 2023,
    },
    {
      Place: "TRIPURA",
      Status1: 77.1,
      Status2: 83.7,
      Status3: 80.1,
      year: 2023,
    },
    {
      Place: "UTTAR PRADESH",
      Status1: 80.4,
      Status2: 83.7,
      Status3: 97.1,
      year: 2023,
    },
    {
      Place: "UTTARAKHAND",
      Status1: 79.8,
      Status2: 78.7,
      Status3: 95.7,
      year: 2023,
    },
    {
      Place: "WEST BENGAL",
      Status1: 91.3,
      Status2: 89.1,
      Status3: 100,
      year: 2023,
    },

    {
      Place: "ANDAMAN & NICOBAR ISLANDS",
      Status1: 51.3,
      Status2: 93,
      Status3: 93.7,
      year: 2025,
    },
    {
      Place: "ANDHRA PRADESH",
      Status1: 89.1,
      Status2: 83.9,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "ARUNACHAL PRADESH",
      Status1: 82.7,
      Status2: 84.6,
      Status3: 95,
      year: 2025,
    },
    { Place: "ASSAM", Status1: 78.8, Status2: 70, Status3: 95, year: 2025 },
    { Place: "BIHAR", Status1: 65.1, Status2: 92.6, Status3: 93.5, year: 2025 },
    {
      Place: "CHANDIGARH",
      Status1: 95,
      Status2: 87,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "CHHATTISGARH",
      Status1: 78,
      Status2: 76,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "DADRA & NAGAR HAVELI",
      Status1: 95,
      Status2: 95,
      Status3: 92.3,
      year: 2025,
    },

    { Place: "DELHI", Status1: 95, Status2: 68.9, Status3: 95, year: 2025 },
    { Place: "GOA", Status1: 95, Status2: 81.6, Status3: 95, year: 2025 },
    {
      Place: "GUJARAT",
      Status1: 87.6,
      Status2: 86.5,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "HARYANA",
      Status1: 74.3,
      Status2: 86.9,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "HIMACHAL PRADESH",
      Status1: 84.2,
      Status2: 91.8,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "JAMMU AND KASHMIR",
      Status1: 67.6,
      Status2: 85.9,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "JHARKHAND",
      Status1: 81,
      Status2: 86.9,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "KARNATAKA",
      Status1: 79.9,
      Status2: 86.9,
      Status3: 95,
      year: 2025,
    },
    { Place: "KERALA", Status1: 80.6, Status2: 95, Status3: 95, year: 2025 },
    // { Place: "LAKSHADWEEP", Status1: 0, Status2: 87.5, Status3: 0, year: 2025 },
    {
      Place: "MADHYA PRADESH",
      Status1: 77.5,
      Status2: 85.2,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "MAHARASHTRA",
      Status1: 92.2,
      Status2: 87,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "MANIPUR",
      Status1: 72.1,
      Status2: 89.4,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "MEGHALAYA",
      Status1: 89.4,
      Status2: 78.9,
      Status3: 95,
      year: 2025,
    },
    { Place: "MIZORAM", Status1: 76.5, Status2: 88.5, Status3: 95, year: 2025 },
    {
      Place: "NAGALAND",
      Status1: 81.1,
      Status2: 79.1,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "ODISHA",
      Status1: 72.8,
      Status2: 82.8,
      Status3: 93.5,
      year: 2025,
    },
    {
      Place: "PUDUCHERRY",
      Status1: 68.2,
      Status2: 82.5,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "PUNJAB",
      Status1: 80.5,
      Status2: 74.8,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "RAJASTHAN",
      Status1: 84.4,
      Status2: 89.2,
      Status3: 94.7,
      year: 2025,
    },
    {
      Place: "SIKKIM",
      Status1: 83.7,
      Status2: 87.4,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "TAMIL NADU",
      Status1: 95,
      Status2: 87.4,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "TELANGANA",
      Status1: 79.9,
      Status2: 95,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "TRIPURA",
      Status1: 70.2,
      Status2: 74.4,
      Status3: 85.6,
      year: 2025,
    },
    {
      Place: "UTTAR PRADESH",
      Status1: 75.7,
      Status2: 85.4,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "UTTARAKHAND",
      Status1: 76.3,
      Status2: 77.9,
      Status3: 95,
      year: 2025,
    },
    {
      Place: "WEST BENGAL",
      Status1: 92.4,
      Status2: 86.6,
      Status3: 95,
      year: 2025,
    },
  ],
  1013: [
    {
      Place: "Andhra Pradesh",
      High: 24,
      Moderate: 1,
      Low: 1,
      VeryLow: 0,
      year: 2023,
    },
    {
      Place: "Arunachal Pradesh",
      High: 1,
      Moderate: 0,
      Low: 1,
      VeryLow: 0,
      year: 2023,
    },
    { Place: "Assam", High: 0, Moderate: 3, Low: 3, VeryLow: 3, year: 2023 },
    { Place: "Bihar", High: 13, Moderate: 7, Low: 11, VeryLow: 0, year: 2023 },

    {
      Place: "Chhattisgarh",
      High: 1,
      Moderate: 3,
      Low: 10,
      VeryLow: 9,
      year: 2023,
    },

    { Place: "Delhi", High: 7, Moderate: 3, Low: 1, VeryLow: 0, year: 2023 },
    { Place: "Goa", High: 0, Moderate: 0, Low: 0, VeryLow: 0, year: 2023 },
    {
      Place: "Gujarat",
      High: 6,
      Moderate: 12,
      Low: 12,
      VeryLow: 3,
      year: 2023,
    },
    { Place: "Haryana", High: 2, Moderate: 9, Low: 2, VeryLow: 0, year: 2023 },
    {
      Place: "Himachal_Pradesh",
      High: 0,
      Moderate: 0,
      Low: 3,
      VeryLow: 9,
      year: 2023,
    },

    {
      Place: "Jharkhand",
      High: 0,
      Moderate: 3,
      Low: 5,
      VeryLow: 5,
      year: 2023,
    },
    {
      Place: "Karnataka",
      High: 24,
      Moderate: 5,
      Low: 2,
      VeryLow: 0,
      year: 2023,
    },
    { Place: "Kerala", High: 2, Moderate: 1, Low: 6, VeryLow: 5, year: 2023 },

    {
      Place: "Madhya Pradesh",
      High: 2,
      Moderate: 3,
      Low: 24,
      VeryLow: 23,
      year: 2023,
    },
    {
      Place: "Maharashtra",
      High: 22,
      Moderate: 10,
      Low: 1,
      VeryLow: 1,
      year: 2023,
    },
    { Place: "Manipur", High: 5, Moderate: 10, Low: 1, VeryLow: 0, year: 2023 },
    {
      Place: "Meghalaya",
      High: 2,
      Moderate: 1,
      Low: 3,
      VeryLow: 0,
      year: 2023,
    },
    { Place: "Mizoram", High: 10, Moderate: 1, Low: 0, VeryLow: 0, year: 2023 },
    { Place: "Mumbai", High: 2, Moderate: 0, Low: 0, VeryLow: 0, year: 2023 },
    {
      Place: "Nagaland",
      High: 10,
      Moderate: 5,
      Low: 1,
      VeryLow: 0,
      year: 2023,
    },
    { Place: "Odisha", High: 1, Moderate: 4, Low: 14, VeryLow: 4, year: 2023 },

    { Place: "Punjab", High: 9, Moderate: 10, Low: 3, VeryLow: 0, year: 2023 },
    {
      Place: "Rajasthan",
      High: 2,
      Moderate: 14,
      Low: 17,
      VeryLow: 0,
      year: 2023,
    },

    {
      Place: "Tamil Nadu",
      High: 15,
      Moderate: 9,
      Low: 9,
      VeryLow: 5,
      year: 2023,
    },
    {
      Place: "Telangana",
      High: 13,
      Moderate: 13,
      Low: 6,
      VeryLow: 1,
      year: 2023,
    },
    { Place: "Tripura", High: 0, Moderate: 3, Low: 1, VeryLow: 0, year: 2023 },
    {
      Place: "Uttar Pradesh",
      High: 13,
      Moderate: 17,
      Low: 26,
      VeryLow: 19,
      year: 2023,
    },
    {
      Place: "Uttarakhand",
      High: 0,
      Moderate: 1,
      Low: 3,
      VeryLow: 2,
      year: 2023,
    },
    {
      Place: "West Bengal",
      High: 5,
      Moderate: 8,
      Low: 5,
      VeryLow: 5,
      year: 2023,
    },

    {
      Place: "Andaman and Nicobar Islands",
      High: 0,
      Moderate: 0,
      Low: 1,
      VeryLow: 2,
      year: 2025,
    },

    {
      Place: "Andhra Pradesh",
      High: 24,
      Moderate: 1,
      Low: 1,
      VeryLow: 0,
      year: 2025,
    },
    {
      Place: "Arunachal Pradesh",
      High: 1,
      Moderate: 1,
      Low: 3,
      VeryLow: 20,
      year: 2025,
    },
    { Place: "Assam", High: 0, Moderate: 4, Low: 5, VeryLow: 24, year: 2025 },
    { Place: "Bihar", High: 13, Moderate: 7, Low: 13, VeryLow: 5, year: 2025 },
    {
      Place: "CHANDIGARH",
      High: 0,
      Moderate: 1,
      Low: 0,
      VeryLow: 0,
      year: 2025,
    },

    {
      Place: "Chhattisgarh",
      High: 2,
      Moderate: 3,
      Low: 10,
      VeryLow: 18,
      year: 2025,
    },

    {
      Place: "Daman and Diu",
      High: 0,
      Moderate: 0,
      Low: 1,
      VeryLow: 2,
      year: 2025,
    },

    { Place: "Delhi", High: 7, Moderate: 4, Low: 0, VeryLow: 0, year: 2025 },
    { Place: "Goa", High: 0, Moderate: 1, Low: 1, VeryLow: 0, year: 2025 },
    {
      Place: "Gujarat",
      High: 5,
      Moderate: 13,
      Low: 12,
      VeryLow: 3,
      year: 2025,
    },
    { Place: "Haryana", High: 2, Moderate: 9, Low: 8, VeryLow: 3, year: 2025 },
    {
      Place: "Himachal_Pradesh",
      High: 0,
      Moderate: 0,
      Low: 3,
      VeryLow: 9,
      year: 2025,
    },

    {
      Place: "Jammu and Kashmir",
      High: 0,
      Moderate: 1,
      Low: 1,
      VeryLow: 20,
      year: 2025,
    },

    {
      Place: "Jharkhand",
      High: 0,
      Moderate: 3,
      Low: 5,
      VeryLow: 5,
      year: 2025,
    },
    {
      Place: "Karnataka",
      High: 24,
      Moderate: 5,
      Low: 2,
      VeryLow: 0,
      year: 2025,
    },
    { Place: "Kerala", High: 2, Moderate: 1, Low: 6, VeryLow: 5, year: 2025 },

    {
      Place: "Madhya Pradesh",
      High: 2,
      Moderate: 3,
      Low: 24,
      VeryLow: 23,
      year: 2025,
    },
    {
      Place: "Maharashtra",
      High: 24,
      Moderate: 10,
      Low: 1,
      VeryLow: 1,
      year: 2025,
    },
    { Place: "Manipur", High: 5, Moderate: 8, Low: 2, VeryLow: 1, year: 2025 },
    {
      Place: "Meghalaya",
      High: 2,
      Moderate: 1,
      Low: 3,
      VeryLow: 6,
      year: 2025,
    },
    { Place: "Mizoram", High: 10, Moderate: 1, Low: 0, VeryLow: 0, year: 2025 },
    // { Place: "Mumbai", High: 2, Moderate: 0, Low: 0, VeryLow: 0, year: 2025 },
    {
      Place: "Nagaland",
      High: 11,
      Moderate: 4,
      Low: 1,
      VeryLow: 0,
      year: 2025,
    },
    { Place: "Odisha", High: 1, Moderate: 4, Low: 14, VeryLow: 11, year: 2025 },
    {
      Place: "Puducherry",
      High: 0,
      Moderate: 0,
      Low: 2,
      VeryLow: 2,
      year: 2025,
    },

    { Place: "Punjab", High: 10, Moderate: 9, Low: 4, VeryLow: 0, year: 2025 },
    {
      Place: "Rajasthan",
      High: 2,
      Moderate: 14,
      Low: 11,
      VeryLow: 6,
      year: 2025,
    },
    {
      Place: "Sikkim",
      High: 0,
      Moderate: 0,
      Low: 0,
      VeryLow: 6,
      year: 2025,
    },

    {
      Place: "Tamil Nadu",
      High: 15,
      Moderate: 13,
      Low: 7,
      VeryLow: 3,
      year: 2025,
    },
    {
      Place: "Telangana",
      High: 13,
      Moderate: 13,
      Low: 6,
      VeryLow: 1,
      year: 2025,
    },
    { Place: "Tripura", High: 0, Moderate: 4, Low: 2, VeryLow: 2, year: 2025 },
    {
      Place: "Uttar Pradesh",
      High: 13,
      Moderate: 17,
      Low: 26,
      VeryLow: 19,
      year: 2025,
    },
    {
      Place: "Uttarakhand",
      High: 0,
      Moderate: 2,
      Low: 2,
      VeryLow: 9,
      year: 2025,
    },
    {
      Place: "West Bengal",
      High: 5,
      Moderate: 8,
      Low: 5,
      VeryLow: 5,
      year: 2025,
    },
  ],
};
